import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a8d9ab4914ef07ab4d0227613edcfaf8fb from "./generated-e39b235e-c14d-47aa-9532-464768768b18.json";

import a32fa075a69e7fecb1dbad3f3f9417724b from "./generated-af41ccf4-6266-45b5-8a31-caa063989b10.json";

import a42aa3f7b998d376cba87c7e7f9a4e39db from "./generated-e3510192-4eac-445b-94f5-47a09bc78e8b.json";

import af6fdbee37c2c5426a49eef5d470f7220b from "./generated-7f541443-cebd-4c16-9c4a-d75d57fe1a29.json";

import ade19eafc552d4dd9316b623b11eba07ab from "./generated-eac10ffd-7aaf-4e95-9b2d-10be64fac908.json";

import a3368451b2f042d82f2c2b6bcc144437db from "./generated-b0ca19c9-02a9-4331-9528-2ebcdfb6be8c.json";

import abe94e4c9049997a02cf7cf5ad20a24f2b from "./generated-7af42f56-a5fd-499e-a7df-ba3709149881.json";

import a68831eb015eb8df0d704369382936d84b from "./generated-35c048d5-d54a-49a4-8e38-92a659c203ca.json";

import acca582d70779b1a3094287e9f1fa63e3b from "./generated-1b8cc56d-853f-42ba-a6fd-9c83ca2c69f8.json";

import af1cb95539898902f51bd7339b4595f19b from "./generated-905c4229-bde5-44ca-986c-5642fd033285.json";

import ac606fd892e5b2e24fc65995bfe768d3cb from "./generated-abd191c0-2b71-4c75-86b1-8d4cbe083d08.json";

import a4a7ae2f4da1e8466037b93e6fa9268d3b from "./generated-b4e105ca-9f20-4446-bd35-973f6c746b3b.json";

import a9a26a2a2ee1a3ef11d9f1691b6e84c5eb from "./generated-00d25cf0-aeda-43a5-a446-4b19a951abe7.json";

import a21fd5df0cb8140240f9d33012e15fdeab from "./generated-8c12c54b-ff9e-4a4a-82dd-98478cf3c980.json";

import a9c34991edf0b6f85d40c98b189275727b from "./generated-9c189d66-f07b-4acd-ad6e-ab2fc47e80f4.json";

import ae4a7c50078bfb7dc41be950a1769bd4eb from "./generated-dca67f3e-1daf-46e9-b3ac-fffe12dc62ef.json";

import ac9363f84c21cc743acfad018b45a85b3b from "./generated-475b81ee-7479-4f82-9914-31694343753e.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a8d9ab4914ef07ab4d0227613edcfaf8fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a32fa075a69e7fecb1dbad3f3f9417724b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a42aa3f7b998d376cba87c7e7f9a4e39db);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(af6fdbee37c2c5426a49eef5d470f7220b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ade19eafc552d4dd9316b623b11eba07ab);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a3368451b2f042d82f2c2b6bcc144437db);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(abe94e4c9049997a02cf7cf5ad20a24f2b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a68831eb015eb8df0d704369382936d84b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(acca582d70779b1a3094287e9f1fa63e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(af1cb95539898902f51bd7339b4595f19b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ac606fd892e5b2e24fc65995bfe768d3cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a4a7ae2f4da1e8466037b93e6fa9268d3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(acca582d70779b1a3094287e9f1fa63e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a9a26a2a2ee1a3ef11d9f1691b6e84c5eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a21fd5df0cb8140240f9d33012e15fdeab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(acca582d70779b1a3094287e9f1fa63e3b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a9c34991edf0b6f85d40c98b189275727b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae4a7c50078bfb7dc41be950a1769bd4eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac9363f84c21cc743acfad018b45a85b3b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a9c34991edf0b6f85d40c98b189275727b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */